import IconButton from "@mui/material/IconButton";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function ToggleButton({ sx = {}, open, onClick, hidden }) {
  const Icon = open ? ArrowBackIosNewIcon : ArrowForwardIosIcon;

  return (
    <IconButton
      sx={{
        backgroundColor: "menu.background",
        color: "menu.font",
        ["&:hover"]: {
          filter: "drop-shadow(0px 0px 10pxrgb(128, 102, 102))",
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Icon />
    </IconButton>
  );
}

export default ToggleButton;
